const indexCategories = [
  { label: '最新电影', icon: 'ri-movie-2-line', desc: '院线新片、网络大电影', count: '12,680' },
  { label: '热播电视剧', icon: 'ri-tv-2-line', desc: '国产剧、韩剧、美剧、日剧', count: '8,950' },
  { label: '综艺节目', icon: 'ri-emotion-laugh-line', desc: '真人秀、脱口秀、选秀', count: '5,420' },
  { label: '动漫番剧', icon: 'ri-ghost-smile-line', desc: '日漫、国漫、剧场版', count: '9,310' },
  { label: '纪录片', icon: 'ri-earth-line', desc: '自然、历史、科技、美食', count: '3,870' },
  { label: '动作冒险', icon: 'ri-fire-line', desc: '枪战、格斗、超级英雄', count: '7,240' },
  { label: '喜剧搞笑', icon: 'ri-emotion-happy-line', desc: '轻松解压笑到停不下来', count: '4,560' },
  { label: '悬疑惊悚', icon: 'ri-ghost-line', desc: '烧脑推理反转不断', count: '3,920' },
  { label: '爱情浪漫', icon: 'ri-heart-2-line', desc: '甜宠虐恋一网打尽', count: '5,180' },
];

export default function IndexSection() {
  return (
    <section id="index" className="w-full bg-background-100">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="text-center mb-10">
          <p className="text-xs md:text-sm font-medium text-secondary-500 uppercase tracking-wide mb-2">影视索引</p>
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">影视索引</h2>
          <p className="mt-2 text-sm text-foreground-500">按分类快速找到你想看的内容</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4 max-w-[960px] mx-auto">
          {indexCategories.map((cat) => (
            <a
              key={cat.label}
              href="#index"
              className="flex items-start gap-4 p-4 md:p-5 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 hover:bg-primary-50/30 transition-all duration-200 cursor-pointer group no-underline"
            >
              <span className="w-10 h-10 rounded-lg flex items-center justify-center bg-secondary-100/70 group-hover:bg-primary-100/70 transition-colors shrink-0">
                <i className={`${cat.icon} text-lg text-secondary-600 group-hover:text-primary-500`}></i>
              </span>
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between">
                  <h3 className="text-sm md:text-base font-medium text-foreground-800">{cat.label}</h3>
                  <span className="text-xs text-foreground-400 shrink-0 ml-2">{cat.count}部</span>
                </div>
                <p className="text-xs text-foreground-500 mt-1">{cat.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}